import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Cashiers only work with day-to-day counter operations. Keep this route
  // guard alongside the sidebar filtering so a pasted URL cannot reveal an
  // administration, procurement, or reporting screen.
  if (user?.role === 'cashier') {
    const path = location.pathname;
    const cashierPaths = ['/pos', '/sales', '/customers', '/refunds/customer', '/medicines'];
    const allowed = cashierPaths.some((basePath) => path === basePath || path.startsWith(`${basePath}/`));
    if (!allowed) {
      return <Navigate to="/pos" replace />;
    }
  }

  return <Outlet />;
}
